<template>
  <label>
    <input
      :id="inputIdComputed"
      ref="input"
      v-model="checkedVal"
      type="checkbox"
      :name="inputName"
      value="1"
      :required="required"
      @change="updateCheckedVal"
    /><slot></slot>
  </label>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CheckBox",
  props: {
    inputId: {
      type: String,
      required: false,
      default: "",
    },
    inputName: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { checkedVal: false };
  },
  computed: {
    ...mapGetters({
      reportTermsValidity: "checkout/reportTermsValidity",
    }),
    inputIdComputed() {
      return this.inpudId || this.inputName;
    },
  },
  watch: {
    reportTermsValidity: {
      handler() {
        if (!this.$refs.input.checkValidity()) {
          this.$refs.input.reportValidity();
        }
      },
    },
  },
  methods: {
    ...mapActions({
      setTermsAccepted: "checkout/setTermsAccepted",
      setReportTermsValidity: "checkout/setReportTermsValidity",
    }),
    updateCheckedVal(e) {
      let isChecked = e.target.checked;
      if (isChecked) {
        this.setReportTermsValidity(false);
        this.setTermsAccepted(true);
      } else {
        this.setReportTermsValidity(true);
        this.setTermsAccepted(false);
      }
    },
  },
};
</script>
